define("@latermedia/ember-later-analytics/components/ui/media-kit/profile-info", ["exports", "@ember/component", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{!-- Header --}}
  <header class="cCI--header">
    {{!-- Avatar --}}
    <div class="cCI--header__avatar">
      <figure class="o--mediaContainer cCI--header__avatarImg">
        <img
  				class="o--media"
  				src={{@profileImage}}
  				alt=""
  			>
      </figure>
    </div>
    {{!-- Info --}}
    <div class="cCI--header__info">
      <h1 class="o--page__title u--m__b__xs qa--mediaKit_clientPage_name">{{@name}}</h1>
      <p class="u--m__b__xs u--text--sm">
        {{ this.formattedLocationAndIndustry }}
      </p>
      <a rel="noopener noreferrer" href={{@website}} target="_blank" class="u--text--sm">{{@website}}</a>
    </div>
  </header>
  {{#if (or this.formattedPastCollabs @platforms)}}
    <hr>
  {{/if}}
  {{#if this.formattedPastCollabs}}
    <div class="cCI--details">
      <div class="cCI--details__icon">
        {{svg-jar "collaborations" class="o--icon--lg"}}
      </div>
      <div class="cCI--details__content">
        <p class="u--m__b__xs u--text--bold">{{t "media_kit.profile.past_collabs" locale="en-us"}}</p>
        <p class="u--m__b__0">{{this.formattedPastCollabs}}</p>
      </div>
    </div>
  {{/if}}
  {{#if @platforms}}
    <div class="cCI--details">
      <div class="cCI--details__icon">
        {{svg-jar "platforms" class="o--icon--lg"}}
      </div>
      <div class="cCI--details__content">
        <p class="u--m__b__xs u--text--bold">{{t "media_kit.profile.social_links" locale="en-us"}}</p>
        <p class="u--m__b__0">
          {{#each @platforms as |platform|}}
            <a rel="noopener noreferrer" href={{platform.url_name}} target="_blank">
              {{platform.platform}}{{svg-jar "arrow-external" class="o--icon--xxs"}}
            </a>
          {{/each}}
        </p>
      </div>
    </div>
  {{/if}}
  
  */
  {
    "id": "TsJR0t56",
    "block": "[[[10,\"header\"],[14,0,\"cCI--header\"],[12],[1,\"\\n\"],[1,\"  \"],[10,0],[14,0,\"cCI--header__avatar\"],[12],[1,\"\\n    \"],[10,\"figure\"],[14,0,\"o--mediaContainer cCI--header__avatarImg\"],[12],[1,\"\\n      \"],[10,\"img\"],[14,0,\"o--media\"],[15,\"src\",[30,1]],[14,\"alt\",\"\"],[12],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[1,\"  \"],[10,0],[14,0,\"cCI--header__info\"],[12],[1,\"\\n    \"],[10,\"h1\"],[14,0,\"o--page__title u--m__b__xs qa--mediaKit_clientPage_name\"],[12],[1,[30,2]],[13],[1,\"\\n    \"],[10,2],[14,0,\"u--m__b__xs u--text--sm\"],[12],[1,\"\\n      \"],[1,[30,0,[\"formattedLocationAndIndustry\"]]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,3],[14,\"rel\",\"noopener noreferrer\"],[15,6,[30,3]],[14,\"target\",\"_blank\"],[14,0,\"u--text--sm\"],[12],[1,[30,3]],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\"],[41,[28,[37,1],[[30,0,[\"formattedPastCollabs\"]],[30,4]],null],[[[1,\"  \"],[10,\"hr\"],[12],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"formattedPastCollabs\"]],[[[1,\"  \"],[10,0],[14,0,\"cCI--details\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"cCI--details__icon\"],[12],[1,\"\\n      \"],[1,[28,[35,2],[\"collaborations\"],[[\"class\"],[\"o--icon--lg\"]]]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"cCI--details__content\"],[12],[1,\"\\n      \"],[10,2],[14,0,\"u--m__b__xs u--text--bold\"],[12],[1,[28,[35,3],[\"media_kit.profile.past_collabs\"],[[\"locale\"],[\"en-us\"]]]],[13],[1,\"\\n      \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,[30,0,[\"formattedPastCollabs\"]]],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null],[41,[30,4],[[[1,\"  \"],[10,0],[14,0,\"cCI--details\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"cCI--details__icon\"],[12],[1,\"\\n      \"],[1,[28,[35,2],[\"platforms\"],[[\"class\"],[\"o--icon--lg\"]]]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"cCI--details__content\"],[12],[1,\"\\n      \"],[10,2],[14,0,\"u--m__b__xs u--text--bold\"],[12],[1,[28,[35,3],[\"media_kit.profile.social_links\"],[[\"locale\"],[\"en-us\"]]]],[13],[1,\"\\n      \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,\"\\n\"],[42,[28,[37,5],[[28,[37,5],[[30,4]],null]],null],null,[[[1,\"          \"],[10,3],[14,\"rel\",\"noopener noreferrer\"],[15,6,[30,5,[\"url_name\"]]],[14,\"target\",\"_blank\"],[12],[1,\"\\n            \"],[1,[30,5,[\"platform\"]]],[1,[28,[35,2],[\"arrow-external\"],[[\"class\"],[\"o--icon--xxs\"]]]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[5]],null],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null]],[\"@profileImage\",\"@name\",\"@website\",\"@platforms\",\"platform\"],false,[\"if\",\"or\",\"svg-jar\",\"t\",\"each\",\"-track-array\"]]",
    "moduleName": "@latermedia/ember-later-analytics/components/ui/media-kit/profile-info.hbs",
    "isStrictMode": false
  });
  class ProfileInfoComponent extends _component2.default {
    get formattedPastCollabs() {
      return this.args.pastCollabs?.join() || '';
    }
    get formattedLocationAndIndustry() {
      if (this.args.location && this.args.industry) {
        return `Located in ${this.args.location} | ${this.args.industry} Industry`;
      }
      if (this.args.industry) {
        return `${this.args.industry} Industry`;
      }
      if (this.args.location) {
        return `Located in ${this.args.location}`;
      }
      return '';
    }
  }
  _exports.default = ProfileInfoComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ProfileInfoComponent);
});